import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from 'src/app/others/services/authentication.service';
import Swal from 'sweetalert2';
import { getGlobalUserInfo } from 'src/app/others/auth/auth-storage';

@Component({
  selector: 'app-key-metrics',
  templateUrl: './key-metrics.component.html',
  styleUrls: ['./key-metrics.component.scss']
})
export class KeyMetricsComponent implements OnInit {
  actionButtons = true;
  isCardDisabled: boolean = true;
  userId: any;
  userInfo = getGlobalUserInfo();
  // Initialize permissions as object with all required keys for template
  permissions: any = {
    keyMetrics: { access: false },
    balance: { view: false },
    clients: { view: false },
    receivables: { view: false },
    discounts: { view: false },
    expenses: { view: false },
    performance: { view: false },
    staffCollections: { view: false },
    tat: { view: false },
    cases: { view: false }
  };

  constructor(private auth: AuthenticationService) { }

  ngOnInit() {
    this.getPermissions();
  }

  getPermissions() {
    // God Mode: instantly grant all permissions
    if (this.auth.isGodMode()) {
      this.permissions = {
        keyMetrics: { access: true },
        balance: { view: true },
        clients: { view: true },
        receivables: { view: true },
        discounts: { view: true },
        expenses: { view: true },
        performance: { view: true },
        staffCollections: { view: true },
        tat: { view: true },
        cases: { view: true }
      };
      return;
    }

    this.auth
      .get("user_permissions/" + this.userInfo?.id || sessionStorage.getItem("userID")).toPromise()
      .then(
        (response: any) => {
          this.permissions = response.permissions.permissions[0];
          if (
            !this.permissions.keyMetrics.access &&
            !this.permissions.balance.view &&
            !this.permissions.clients.view &&
            !this.permissions.receivables.view &&
            !this.permissions.discounts.view &&
            !this.permissions.expenses.view &&
            !this.permissions.performance.view &&
            !this.permissions.staffCollections.view &&
            !this.permissions.tat.view &&
            !this.permissions.cases.view
          ) {
            // Show a Swal alert if the user has no permissions
            Swal.fire({
              icon: 'error',
              title: 'Permission Denied',
              text: 'You do not have permission to access this page.',
            });
          }
        });
  }
}
